export class SectionModel{
    Name:string;
    SchoolId:string;
}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/components/manageuser/sections/sections.model.ts